import React from 'react';
import { Tooltip, OverlayTrigger } from 'react-bootstrap';

const renderTooltip = (props, text) => (
  <Tooltip id="button-tooltip" {...props}>
    {text}
  </Tooltip>
);

export default function ButtonCompontent({ onClick, isDisabled, show, tooltipText, icon }) {
  return show ? (
    <OverlayTrigger placement="auto" delay={{ show: 250, hide: 400 }} overlay={(props) => renderTooltip(props, tooltipText)}>
      <button type="button" onClick={onClick} className="filter-btn filter-button_add" disabled={isDisabled}>
        <span className="text-icon">{tooltipText}</span>
        <i className={icon} />
      </button>
    </OverlayTrigger>
  ) : null;
}

export function ActionComponent({
  deleteAction,
  activeAction,
  showActiveBtn,
  isActive,
  MasterDeleteAccess,
  MasterAddEditAccess,
  documentMasterTypes,
  settingAction,
  cardDetails,
  t,
}) {
  const renderButton = (tooltipText, icon, onClick, shouldShow = true) => {
    if (shouldShow) {
      return (
        <OverlayTrigger placement="auto" delay={{ show: 250, hide: 400 }} overlay={(props) => renderTooltip(props, tooltipText)}>
          <button type="button" aria-label={tooltipText} onClick={onClick}>
            <span className={icon} />
          </button>
        </OverlayTrigger>
      );
    }
  };
  const infoText = cardDetails?._id && !cardDetails?._id?.includes('_id') ? t('DOCUMENT_TYPE.INFO_TEXT_ADD') : t('DOCUMENT_TYPE.INFO_TEXT');
  return (
    <div className="input-action">
      {MasterAddEditAccess &&
        !cardDetails?.isDefault &&
        renderButton(t('DOCUMENT_TYPE.ACTIVE/DEACTIVE'), isActive ? 'icon-active' : 'icon-inactive', activeAction, showActiveBtn)}
      {documentMasterTypes.value === 'supplier' &&
        cardDetails?._id &&
        !cardDetails?._id?.includes('_id') &&
        renderButton(t('DOCUMENT_TYPE.SETTINGS'), 'icon-settings', settingAction)}
      {documentMasterTypes.value === 'supplier' && renderButton(infoText, 'icon-info')}

      {MasterDeleteAccess && !cardDetails?.isDefault && renderButton(t('DOCUMENT_TYPE.DELETE'), 'icon-delete mt-3 f-20', deleteAction)}
    </div>
  );
}
